import React, { useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Text,
  Flex
} from '@chakra-ui/react';

interface AleaProgressModalProps {
  isOpen: boolean;
  message: string;
  onClose?: () => void;
}

const AleaProgressModal: React.FC<AleaProgressModalProps> = ({
  isOpen,
  message,
  onClose,
}) => {
  // Notify header about modal state changes
  useEffect(() => {
    const event = new CustomEvent('alea-global-modal-open', { detail: isOpen });
    window.dispatchEvent(event);
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose || (() => {})} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent minWidth="300px" maxWidth="342px" minHeight="74px" borderRadius="20px" p="0">
        <ModalBody textAlign="center" p="0">
          <Flex direction="column" alignItems="center" gap={4}>
            <Text fontSize="20px" fontWeight={500} color="black" p="25px">
              {message}
            </Text>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AleaProgressModal;